// extracted by mini-css-extract-plugin
export default {"checkBoxesContainer":"CheckBoxs_checkBoxesContainer__+wAzu","checkBoxLabel":"CheckBoxs_checkBoxLabel__poUAO","checkBox":"CheckBoxs_checkBox__vE6is"};